import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const saved = localStorage.getItem('user');
    const savedPerms = localStorage.getItem('permissions');
    if (token && saved) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(JSON.parse(saved));
      setPermissions(savedPerms ? JSON.parse(savedPerms) : []);
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const { data } = await axios.post('/api/auth/login', { username, password });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('permissions', JSON.stringify(data.permissions || []));
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUser(data.user);
    setPermissions(data.permissions || []);
    return data;
  };

  const logout = () => {
    localStorage.clear();
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setPermissions([]);
  };

  const can = (page, action = 'view') => {
    if (!user) return false;
    if (user.role === 'superadmin') return true;
    const perm = permissions.find(p => p.page === page);
    if (!perm) return false;
    if (action === 'view') return !!perm.can_view;
    if (action === 'create') return !!perm.can_create;
    if (action === 'edit') return !!perm.can_edit;
    if (action === 'delete') return !!perm.can_delete;
    return false;
  };

  return (
    <AuthContext.Provider value={{ user, permissions, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
